<template>
  <the-section :title="$t('ec-line009.subscriptionInfoTitle')">
    <template v-if="!hasCorporateFlag" #subTitle>
      <el-button class="section__button mr-2" @click="toProductsList">{{ $t('common.action.toNewOrder') }}</el-button>
    </template>
    <el-row>
      <el-tabs v-if="subscriptionPaused.length" v-model="tab">
        <el-tab-pane :label="$t('ec-line009.tabs.subscriptionsNormal')" :name="Constants.EC_LINE009.TABS_TYPE.NORMAL">
          <div v-if="subscriptionNormal.length" class="p-4">
            <subscription-items
              v-for="item in subscriptionNormal.slice(0, 3)"
              :ref="item.ref"
              :key="item.id"
              :data="item"
            ></subscription-items>
          </div>
          <p v-else class="text-center">{{ $t('common.messages.noSubscriptionNormal') }}</p>
        </el-tab-pane>
        <el-tab-pane :label="$t('ec-line009.tabs.subscriptionsPaused')" :name="Constants.EC_LINE009.TABS_TYPE.PAUSED">
          <div class="p-4">
            <subscription-items
              v-for="item in subscriptionPaused.slice(0, 3)"
              :ref="item.ref"
              :key="item.id"
              :data="item"
              :is-running="false"
            ></subscription-items>
          </div>
        </el-tab-pane>
      </el-tabs>
      <template v-else>
        <subscription-items
          v-for="item in subscriptionNormal.slice(0, 3)"
          :ref="item.ref"
          :key="item.id"
          :data="item"
        ></subscription-items>
      </template>
      <p v-if="!subscriptionPaused.length && !subscriptionNormal.length" class="text-center">
        {{ $t('common.messages.noSubscription') }}
      </p>
    </el-row>
    <div
      v-if="subscriptionNormal.length > 3 && tab !== Constants.EC_LINE009.TABS_TYPE.PAUSED"
      class="w-full mt-6 flex justify-center"
    >
      <el-button class="cancel-btn font-bold text-base lg:text-lg leading-normal" @click="toSubscriptionsPage">
        {{ $t('ec-line009.subscriptionList.showMore') }}
      </el-button>
    </div>
    <div
      v-if="subscriptionPaused.length > 3 && tab === Constants.EC_LINE009.TABS_TYPE.PAUSED"
      class="w-full mt-6 flex justify-center"
    >
      <el-button class="cancel-btn font-bold text-base lg:text-lg leading-normal" @click="toSubscriptionsPage">
        {{ $t('ec-line009.subscriptionList.showMore') }}
      </el-button>
    </div>
  </the-section>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import SubscriptionItems from '@/components/ec-line009/SubscriptionItems.vue'

export default {
  name: 'SubscriptionInformation',
  components: { TheSection, SubscriptionItems },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab: this.Constants.EC_LINE009.TABS_TYPE.NORMAL,
    }
  },
  computed: {
    subscriptionNormal() {
      return this.data.filter((item) => item.subscription_status_id !== this.Constants.SUBSCRIPTION_STATUS.PAUSE)
    },
    subscriptionPaused() {
      return this.data.filter((item) => item.subscription_status_id === this.Constants.SUBSCRIPTION_STATUS.PAUSE)
    },
    hasCorporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
  },
  watch: {
    data() {
      if (!this.subscriptionNormal.length && this.subscriptionPaused.length) {
        this.tab = this.Constants.EC_LINE009.TABS_TYPE.PAUSED
      }
    },
    tab(val) {
      this.$store.commit('subscription/SET_SUB_LIST_TYPE', val)
    },
  },
  created() {
    this.tab = this.$store.getters['subscription/getSubListType']
  },
  methods: {
    toSubscriptionsPage() {
      this.$router.push({
        name: 'EC_LINE014',
      })
    },
    toProductsList() {
      this.$router.push({ name: 'EC_LINE001' })
    },
  },
}
</script>
